<template>
  <div>
    <v-menu
      v-model="isShowMenu"
      :close-on-content-click="false"
      :open-on-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          data-test="historyCtxMenu"
          v-on="on"
          @click="isShowMenu = true"
          icon
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list width="270">
        <v-list-item
          :data-test="item.text"
          @click="selectDate(item, index)"
          v-for="(item, index) in contextMenu"
          :key="item.id"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon v-if="item.isCheck">
            <v-icon>mdi-check</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider />
        <v-list-item @click="downloadPopupHistory" data-test-action="downloadHistory">
          <v-list-item-icon>
            <v-icon>mdi-download</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Download history
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { subDays, subWeeks, subMonths, formatISO } from 'date-fns';
import { onMounted, reactive, toRefs, watch } from '@vue/composition-api';

export default {
  name: 'HistoryDropdown',
  setup(props, context) {
    const data = reactive({
      dateRange: '',
      showPopup: false,
      isShowMenu: false,
      modeSelection: 'day',
      contextMenu: [
        {
          id: 'day',
          text: 'Day',
          icon: 'mdi-calendar',
          isCheck: true
        },
        {
          id: 'week',
          text: 'Week',
          icon: 'mdi-calendar',
          isCheck: false
        },
        {
          id: 'month',
          text: 'Month',
          icon: 'mdi-calendar',
          isCheck: false
        }
      ]
    });

    const computeDate = value => {
      let dateNow = new Date();
      let datePrev = null;
      if (value === 'day') {
        datePrev = subDays(dateNow, 1);
      } else if (value === 'month') {
        datePrev = subMonths(dateNow, 1);
      } else if (value === 'week') {
        datePrev = subWeeks(dateNow, 1);
      }
      context.emit('date-range', [
        formatISO(dateNow, { representation: 'date' }),
        formatISO(datePrev, { representation: 'date' })
      ]);
    };

    const downloadPopupHistory = () => {
      context.emit('select-date', data.dateRange, data.modeSelection);
    };

    const selectDate = (item, indexClick) => {
      data.contextMenu.forEach((item, index) => {
        item.isCheck = false;
        if (index === indexClick) {
          data.modeSelection = item.id;
          item.isCheck = true;
        }
      });
    };

    watch(
      () => data.modeSelection,
      (value, oldValue) => {
        if (value !== oldValue) {
          computeDate(value);
        }
      }
    );

    onMounted(() => {
      computeDate(data.modeSelection);
    });

    return {
      ...toRefs(data),
      selectDate,
      downloadPopupHistory
    };
  }
};
</script>
